import { Component, Input } from "@angular/core";
import { PortingData } from "src/app/meta/PortingData.interface";

@Component({
    selector: "ow-order-summary-porting",
    templateUrl: "./order-summary-porting.component.html"
})
export class OrderSummaryPortingComponent {

    @Input() portingData!: PortingData
    @Input() portingNumbers!: string

}
